import React from 'react';
import { dotStyle } from '@fabric-ui/theme';
import { Box } from '@mui/material';

interface ColorItemProps {
  item: string;
  isActive?: boolean;
  onClick?: () => void;
  size?: number;
  ref?: React.ForwardedRef<HTMLInputElement>;
  'aria-label'?: string;
}

export const ColorItem = ({ item: color, onClick, isActive = false, size = 20, ref, 'aria-label': ariaLabel }: ColorItemProps) => (
  <Box
    sx={{
      ...(onClick && { p: '2px' }),
      borderRadius: '50%',
      border: onClick && `2px solid ${isActive ? 'var(--color-border-base-secondary)' : 'transparent'}`,
      transition: theme =>
        theme.transitions.create('border-color', {
          duration: theme.transitions.duration.shortest,
        }),
    }}>
    <Box
      ref={ref}
      sx={{
        ...dotStyle(color, size),
        ...(onClick && { cursor: 'pointer' }),
        outline: `2px solid var(--color-surface-base-primary)`,
      }}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      aria-label={ariaLabel}
    />
  </Box>
);
